export default { "columns":45,
 "image":"cryolab-ground-tiles.png",
 "imageheight":512,
 "imagewidth":720,
 "margin":0,
 "name":"cryolab-ground-tiles",
 "spacing":0,
 "tilecount":1440,
 "tiledversion":"1.11.0",
 "tileheight":16,
 "tiles":[
        {
         "id":5,
         "type":"decal"
        }, 
        {
         "id":6,
         "type":"decal"
        }, 
        {
         "id":7,
         "type":"decal"
        }, 
        {
         "id":16,
         "type":"decal"
        }, 
        {
         "id":26,
         "type":"decal"
        }, 
        {
         "id":27,
         "type":"decal"
        }, 
        {
         "id":28,
         "type":"decal"
        }, 
        {
         "id":29,
         "type":"decal"
        }, 
        {
         "id":30,
         "type":"decal"
        }, 
        {
         "id":31,
         "type":"decal"
        }, 
        {
         "id":32,
         "type":"decal"
        }, 
        {
         "id":33,
         "type":"decal"
        }, 
        {
         "id":34,
         "type":"decal"
        }, 
        {
         "id":35,
         "type":"decal"
        }, 
        {
         "id":36,
         "type":"decal"
        }, 
        {
         "id":37,
         "type":"decal"
        }, 
        {
         "id":38,
         "type":"decal"
        }, 
        {
         "id":39,
         "type":"decal"
        }, 
        {
         "id":40,
         "type":"decal"
        }, 
        {
         "id":41,
         "type":"decal"
        }, 
        {
         "id":42,
         "type":"decal"
        }, 
        {
         "id":43,
         "type":"decal"
        }, 
        {
         "id":50,
         "type":"ground"
        }, 
        {
         "id":51,
         "type":"ground"
        }, 
        {
         "id":52,
         "objectgroup":
            {
             "draworder":"index",
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":16,
                             "y":16
                            }, 
                            {
                             "x":0,
                             "y":16
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":0,
                     "y":0
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"stairsdiagright"
        }, 
        {
         "id":53,
         "type":"decal"
        }, 
        {
         "id":60,
         "type":"decal"
        }, 
        {
         "id":61,
         "objectgroup":
            {
             "draworder":"index",
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":16,
                             "y":-16
                            }, 
                            {
                             "x":16,
                             "y":0
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":0,
                     "y":16
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"stairsdiagleft"
        }, 
        {
         "id":70,
         "type":"decal"
        }, 
        {
         "id":71,
         "type":"decal"
        }, 
        {
         "id":72,
         "type":"decal"
        }, 
        {
         "id":73,
         "type":"decal"
        }, 
        {
         "id":74,
         "type":"decal"
        }, 
        {
         "id":75,
         "type":"decal"
        }, 
        {
         "id":76,
         "type":"decal"
        }, 
        {
         "id":77,
         "type":"decal"
        }, 
        {
         "id":78,
         "type":"decal"
        }, 
        {
         "id":79,
         "type":"decal"
        }, 
        {
         "id":80,
         "type":"decal"
        }, 
        {
         "id":81,
         "type":"decal"
        }, 
        {
         "id":82,
         "type":"decal"
        }, 
        {
         "id":83,
         "type":"decal"
        }, 
        {
         "id":84,
         "type":"decal"
        }, 
        {
         "id":85,
         "type":"decal"
        }, 
        {
         "id":86,
         "type":"decal"
        }, 
        {
         "id":87,
         "type":"decal"
        }, 
        {
         "id":88,
         "type":"decal"
        }, 
        {
         "id":95,
         "type":"decal"
        }, 
        {
         "id":96,
         "type":"decal"
        }, 
        {
         "id":97,
         "type":"decal"
        }, 
        {
         "id":98,
         "objectgroup":
            {
             "draworder":"index",
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":16,
                             "y":16
                            }, 
                            {
                             "x":0,
                             "y":16
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":0,
                     "y":0
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"stairsdiagright"
        }, 
        {
         "id":99,
         "type":"decal"
        }, 
        {
         "id":104,
         "type":"decal"
        }, 
        {
         "id":105,
         "objectgroup":
            {
             "draworder":"index",
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":16,
                             "y":-16
                            }, 
                            {
                             "x":16,
                             "y":0
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":0,
                     "y":16
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"stairsdiagleft"
        }, 
        {
         "id":106,
         "type":"decal"
        }, 
        {
         "id":114,
         "type":"ground"
        }, 
        {
         "id":115,
         "type":"ground"
        }, 
        {
         "id":116,
         "type":"ground"
        }, 
        {
         "id":117,
         "type":"ground"
        }, 
        {
         "id":118,
         "type":"ground"
        }, 
        {
         "id":119,
         "type":"ground"
        }, 
        {
         "id":120,
         "type":"ground"
        }, 
        {
         "id":121,
         "type":"ground"
        }, 
        {
         "id":122,
         "type":"ground"
        }, 
        {
         "id":123,
         "type":"ground"
        }, 
        {
         "id":124,
         "type":"ground"
        }, 
        {
         "id":125,
         "type":"ground"
        }, 
        {
         "id":126,
         "type":"ground"
        }, 
        {
         "id":127,
         "type":"ground"
        }, 
        {
         "id":128,
         "type":"ground"
        }, 
        {
         "id":129,
         "type":"ground"
        }, 
        {
         "id":130,
         "type":"ground"
        }, 
        {
         "id":131,
         "type":"ground"
        }, 
        {
         "id":132,
         "type":"ground"
        }, 
        {
         "id":133,
         "type":"ground"
        }, 
        {
         "id":140,
         "type":"decal"
        }, 
        {
         "id":141,
         "type":"decal"
        }, 
        {
         "id":142,
         "type":"decal"
        }, 
        {
         "id":143,
         "type":"decal"
        }, 
        {
         "id":144,
         "objectgroup":
            {
             "draworder":"index",
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":16,
                             "y":16
                            }, 
                            {
                             "x":0,
                             "y":16
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":0,
                     "y":0
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"stairsdiagright"
        }, 
        {
         "id":145,
         "type":"decal"
        }, 
        {
         "id":148,
         "type":"decal"
        }, 
        {
         "id":149,
         "objectgroup":
            {
             "draworder":"index",
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":16,
                             "y":-16
                            }, 
                            {
                             "x":16,
                             "y":0
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":0,
                     "y":16
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"stairsdiagleft"
        }, 
        {
         "id":150,
         "type":"decal"
        }, 
        {
         "id":151,
         "type":"decal"
        }, 
        {
         "id":158,
         "type":"ground"
        }, 
        {
         "id":159,
         "type":"ground"
        }, 
        {
         "id":160,
         "type":"ground"
        }, 
        {
         "id":161,
         "type":"ground"
        }, 
        {
         "id":162,
         "type":"ground"
        }, 
        {
         "id":163,
         "type":"ground"
        }, 
        {
         "id":164,
         "type":"ground"
        }, 
        {
         "id":165,
         "type":"ground"
        }, 
        {
         "id":166,
         "type":"ground"
        }, 
        {
         "id":167,
         "type":"ground"
        }, 
        {
         "id":168,
         "type":"ground"
        }, 
        {
         "id":169,
         "type":"ground"
        }, 
        {
         "id":170,
         "type":"ground"
        }, 
        {
         "id":171,
         "type":"ground"
        }, 
        {
         "id":172,
         "type":"ground"
        }, 
        {
         "id":173,
         "type":"ground"
        }, 
        {
         "id":174,
         "type":"ground"
        }, 
        {
         "id":175,
         "type":"ground"
        }, 
        {
         "id":176,
         "type":"ground"
        }, 
        {
         "id":177,
         "type":"ground"
        }, 
        {
         "id":178,
         "type":"decal"
        }, 
        {
         "id":181,
         "type":"decal"
        }, 
        {
         "id":183,
         "type":"decal"
        }, 
        {
         "id":187,
         "type":"decal"
        }, 
        {
         "id":188,
         "type":"decal"
        }, 
        {
         "id":189,
         "type":"decal"
        }, 
        {
         "id":190,
         "objectgroup":
            {
             "draworder":"index",
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":16,
                             "y":16
                            }, 
                            {
                             "x":0,
                             "y":16
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":0,
                     "y":0
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"stairsdiagright"
        }, 
        {
         "id":191,
         "type":"decal"
        }, 
        {
         "id":192,
         "type":"decal"
        }, 
        {
         "id":193,
         "objectgroup":
            {
             "draworder":"index",
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":16,
                             "y":-16
                            }, 
                            {
                             "x":16,
                             "y":0
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":0,
                     "y":16
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"stairsdiagleft"
        }, 
        {
         "id":194,
         "type":"decal"
        }, 
        {
         "id":195,
         "type":"decal"
        }, 
        {
         "id":196,
         "type":"decal"
        }, 
        {
         "id":202,
         "type":"decal"
        }, 
        {
         "id":203,
         "type":"decal"
        }, 
        {
         "id":204,
         "type":"decal"
        }, 
        {
         "id":205,
         "type":"decal"
        }, 
        {
         "id":206,
         "type":"decal"
        }, 
        {
         "id":207,
         "type":"decal"
        }, 
        {
         "id":208,
         "type":"decal"
        }, 
        {
         "id":209,
         "type":"decal"
        }, 
        {
         "id":210,
         "type":"decal"
        }, 
        {
         "id":211,
         "type":"decal"
        }, 
        {
         "id":212,
         "type":"decal"
        }, 
        {
         "id":213,
         "type":"decal"
        }, 
        {
         "id":214,
         "type":"decal"
        }, 
        {
         "id":215,
         "type":"decal"
        }, 
        {
         "id":216,
         "type":"decal"
        }, 
        {
         "id":217,
         "type":"decal"
        }, 
        {
         "id":218,
         "type":"decal"
        }, 
        {
         "id":219,
         "type":"decal"
        }, 
        {
         "id":220,
         "type":"decal"
        }, 
        {
         "id":221,
         "type":"decal"
        }, 
        {
         "id":222,
         "type":"decal"
        }, 
        {
         "id":223,
         "type":"decal"
        }, 
        {
         "id":226,
         "type":"ground"
        }, 
        {
         "id":228,
         "type":"ground"
        }, 
        {
         "id":233,
         "type":"decal"
        }, 
        {
         "id":234,
         "type":"decal"
        }, 
        {
         "id":235,
         "type":"decal"
        }, 
        {
         "id":236,
         "type":"ground"
        }, 
        {
         "id":237,
         "type":"ground"
        }, 
        {
         "id":238,
         "type":"decal"
        }, 
        {
         "id":239,
         "type":"decal"
        }, 
        {
         "id":240,
         "type":"decal"
        }, 
        {
         "id":247,
         "type":"decal"
        }, 
        {
         "id":248,
         "type":"decal"
        }, 
        {
         "id":249,
         "type":"decal"
        }, 
        {
         "id":250,
         "type":"decal"
        }, 
        {
         "id":251,
         "type":"decal"
        }, 
        {
         "id":252,
         "type":"decal"
        }, 
        {
         "id":253,
         "type":"decal"
        }, 
        {
         "id":254,
         "type":"decal"
        }, 
        {
         "id":255,
         "type":"decal"
        }, 
        {
         "id":256,
         "type":"decal"
        }, 
        {
         "id":257,
         "type":"decal"
        }, 
        {
         "id":258,
         "type":"decal"
        }, 
        {
         "id":259,
         "type":"decal"
        }, 
        {
         "id":260,
         "type":"decal"
        }, 
        {
         "id":261,
         "type":"decal"
        }, 
        {
         "id":262,
         "type":"decal"
        }, 
        {
         "id":263,
         "type":"decal"
        }, 
        {
         "id":264,
         "type":"decal"
        }, 
        {
         "id":265,
         "type":"decal"
        }, 
        {
         "id":266,
         "type":"decal"
        }, 
        {
         "id":267,
         "type":"decal"
        }, 
        {
         "id":268,
         "type":"decal"
        }, 
        {
         "id":271,
         "type":"decal"
        }, 
        {
         "id":273,
         "type":"decal"
        }, 
        {
         "id":279,
         "type":"decal"
        }, 
        {
         "id":280,
         "type":"decal"
        }, 
        {
         "id":281,
         "type":"decal"
        }, 
        {
         "id":282,
         "type":"decal"
        }, 
        {
         "id":283,
         "type":"decal"
        }, 
        {
         "id":284,
         "type":"decal"
        }, 
        {
         "id":293,
         "type":"decal"
        }, 
        {
         "id":294,
         "type":"decal"
        }, 
        {
         "id":295,
         "type":"decal"
        }, 
        {
         "id":296,
         "type":"decal"
        }, 
        {
         "id":297,
         "type":"decal"
        }, 
        {
         "id":298,
         "type":"decal"
        }, 
        {
         "id":299,
         "type":"decal"
        }, 
        {
         "id":300,
         "type":"decal"
        }, 
        {
         "id":301,
         "type":"decal"
        }, 
        {
         "id":302,
         "type":"decal"
        }, 
        {
         "id":303,
         "type":"decal"
        }, 
        {
         "id":304,
         "type":"decal"
        }, 
        {
         "id":305,
         "type":"decal"
        }, 
        {
         "id":306,
         "type":"decal"
        }, 
        {
         "id":307,
         "type":"decal"
        }, 
        {
         "id":308,
         "type":"decal"
        }, 
        {
         "id":309,
         "type":"decal"
        }, 
        {
         "id":310,
         "type":"decal"
        }, 
        {
         "id":311,
         "type":"decal"
        }, 
        {
         "id":312,
         "type":"decal"
        }, 
        {
         "id":313,
         "type":"decal"
        }, 
        {
         "id":316,
         "type":"decal"
        }, 
        {
         "id":318,
         "type":"decal"
        }, 
        {
         "id":325,
         "type":"decal"
        }, 
        {
         "id":326,
         "type":"decal"
        }, 
        {
         "id":327,
         "type":"decal"
        }, 
        {
         "id":328,
         "type":"decal"
        }, 
        {
         "id":339,
         "type":"decal"
        }, 
        {
         "id":340,
         "type":"decal"
        }, 
        {
         "id":341,
         "type":"decal"
        }, 
        {
         "id":342,
         "type":"decal"
        }, 
        {
         "id":343,
         "type":"decal"
        }, 
        {
         "id":344,
         "type":"decal"
        }, 
        {
         "id":347,
         "type":"decal"
        }, 
        {
         "id":348,
         "type":"decal"
        }, 
        {
         "id":349,
         "type":"decal"
        }, 
        {
         "id":350,
         "type":"decal"
        }, 
        {
         "id":351,
         "type":"decal"
        }, 
        {
         "id":352,
         "type":"decal"
        }, 
        {
         "id":361,
         "type":"decal"
        }, 
        {
         "id":363,
         "type":"decal"
        }, 
        {
         "id":364,
         "type":"decal"
        }, 
        {
         "id":365,
         "type":"decal"
        }, 
        {
         "id":366,
         "type":"decal"
        }, 
        {
         "id":367,
         "type":"decal"
        }, 
        {
         "id":368,
         "type":"decal"
        }, 
        {
         "id":369,
         "type":"decal"
        }, 
        {
         "id":370,
         "type":"decal"
        }, 
        {
         "id":371,
         "type":"decal"
        }, 
        {
         "id":372,
         "type":"decal"
        }, 
        {
         "id":373,
         "type":"decal"
        }, 
        {
         "id":374,
         "type":"decal"
        }, 
        {
         "id":375,
         "type":"decal"
        }, 
        {
         "id":376,
         "type":"decal"
        }, 
        {
         "id":377,
         "type":"decal"
        }, 
        {
         "id":378,
         "type":"decal"
        }, 
        {
         "id":379,
         "type":"decal"
        }, 
        {
         "id":380,
         "type":"decal"
        }, 
        {
         "id":384,
         "type":"decal"
        }, 
        {
         "id":385,
         "type":"decal"
        }, 
        {
         "id":386,
         "type":"decal"
        }, 
        {
         "id":387,
         "type":"decal"
        }, 
        {
         "id":388,
         "type":"decal"
        }, 
        {
         "id":389,
         "type":"decal"
        }, 
        {
         "id":390,
         "type":"decal"
        }, 
        {
         "id":392,
         "type":"decal"
        }, 
        {
         "id":393,
         "type":"decal"
        }, 
        {
         "id":394,
         "type":"decal"
        }, 
        {
         "id":395,
         "type":"decal"
        }, 
        {
         "id":396,
         "type":"decal"
        }, 
        {
         "id":397,
         "type":"decal"
        }, 
        {
         "id":398,
         "type":"decal"
        }, 
        {
         "id":399,
         "type":"decal"
        }, 
        {
         "id":406,
         "type":"ground"
        }, 
        {
         "id":408,
         "type":"ground"
        }, 
        {
         "id":409,
         "type":"ground"
        }, 
        {
         "id":410,
         "type":"ground"
        }, 
        {
         "id":411,
         "type":"ground"
        }, 
        {
         "id":412,
         "type":"ground"
        }, 
        {
         "id":413,
         "type":"ground"
        }, 
        {
         "id":414,
         "type":"ground"
        }, 
        {
         "id":415,
         "type":"ground"
        }, 
        {
         "id":416,
         "type":"ground"
        }, 
        {
         "id":417,
         "type":"ground"
        }, 
        {
         "id":418,
         "type":"ground"
        }, 
        {
         "id":419,
         "type":"ground"
        }, 
        {
         "id":420,
         "type":"ground"
        }, 
        {
         "id":421,
         "type":"ground"
        }, 
        {
         "id":422,
         "type":"ground"
        }, 
        {
         "id":423,
         "type":"ground"
        }, 
        {
         "id":424,
         "type":"ground"
        }, 
        {
         "id":425,
         "type":"decal"
        }, 
        {
         "id":429,
         "type":"ground"
        }, 
        {
         "id":430,
         "type":"ground"
        }, 
        {
         "id":431,
         "type":"ground"
        }, 
        {
         "id":432,
         "type":"ground"
        }, 
        {
         "id":433,
         "type":"ground"
        }, 
        {
         "id":434,
         "type":"ground"
        }, 
        {
         "id":435,
         "type":"ground"
        }, 
        {
         "id":436,
         "type":"ground"
        }, 
        {
         "id":437,
         "type":"ground"
        }, 
        {
         "id":438,
         "type":"ground"
        }, 
        {
         "id":439,
         "type":"ground"
        }, 
        {
         "id":440,
         "type":"ground"
        }, 
        {
         "id":441,
         "type":"ground"
        }, 
        {
         "id":442,
         "type":"ground"
        }, 
        {
         "id":443,
         "type":"ground"
        }, 
        {
         "id":444,
         "type":"ground"
        }, 
        {
         "id":451,
         "type":"decal"
        }, 
        {
         "id":453,
         "type":"ground"
        }, 
        {
         "id":454,
         "type":"ground"
        }, 
        {
         "id":455,
         "type":"ground"
        }, 
        {
         "id":456,
         "type":"ground"
        }, 
        {
         "id":457,
         "type":"ground"
        }, 
        {
         "id":458,
         "type":"ground"
        }, 
        {
         "id":459,
         "type":"ground"
        }, 
        {
         "id":460,
         "type":"ground"
        }, 
        {
         "id":461,
         "type":"ground"
        }, 
        {
         "id":462,
         "type":"ground"
        }, 
        {
         "id":463,
         "type":"ground"
        }, 
        {
         "id":464,
         "type":"ground"
        }, 
        {
         "id":465,
         "type":"ground"
        }, 
        {
         "id":466,
         "type":"ground"
        }, 
        {
         "id":467,
         "type":"ground"
        }, 
        {
         "id":468,
         "type":"ground"
        }, 
        {
         "id":469,
         "type":"ground"
        }, 
        {
         "id":470,
         "type":"decal"
        }, 
        {
         "id":474,
         "type":"decal"
        }, 
        {
         "id":475,
         "type":"decal"
        }, 
        {
         "id":476,
         "type":"decal"
        }, 
        {
         "id":477,
         "type":"decal"
        }, 
        {
         "id":478,
         "type":"decal"
        }, 
        {
         "id":479,
         "type":"decal"
        }, 
        {
         "id":480,
         "type":"decal"
        }, 
        {
         "id":481,
         "type":"decal"
        }, 
        {
         "id":482,
         "type":"decal"
        }, 
        {
         "id":483,
         "type":"decal"
        }, 
        {
         "id":484,
         "type":"decal"
        }, 
        {
         "id":485,
         "type":"decal"
        }, 
        {
         "id":486,
         "type":"decal"
        }, 
        {
         "id":487,
         "type":"decal"
        }, 
        {
         "id":488,
         "type":"decal"
        }, 
        {
         "id":489,
         "type":"decal"
        }, 
        {
         "id":496,
         "type":"decal"
        }, 
        {
         "id":498,
         "type":"decal"
        }, 
        {
         "id":499,
         "type":"decal"
        }, 
        {
         "id":500,
         "type":"decal"
        }, 
        {
         "id":501,
         "type":"decal"
        }, 
        {
         "id":502,
         "type":"decal"
        }, 
        {
         "id":503,
         "type":"decal"
        }, 
        {
         "id":504,
         "type":"decal"
        }, 
        {
         "id":505,
         "type":"decal"
        }, 
        {
         "id":506,
         "type":"decal"
        }, 
        {
         "id":507,
         "type":"decal"
        }, 
        {
         "id":508,
         "type":"decal"
        }, 
        {
         "id":509,
         "type":"decal"
        }, 
        {
         "id":510,
         "type":"decal"
        }, 
        {
         "id":511,
         "type":"decal"
        }, 
        {
         "id":512,
         "type":"decal"
        }, 
        {
         "id":513,
         "type":"decal"
        }, 
        {
         "id":514,
         "type":"decal"
        }, 
        {
         "id":519,
         "type":"decal"
        }, 
        {
         "id":520,
         "type":"decal"
        }, 
        {
         "id":521,
         "type":"decal"
        }, 
        {
         "id":522,
         "type":"decal"
        }, 
        {
         "id":523,
         "type":"decal"
        }, 
        {
         "id":524,
         "type":"decal"
        }, 
        {
         "id":525,
         "type":"decal"
        }, 
        {
         "id":526,
         "type":"decal"
        }, 
        {
         "id":527,
         "type":"decal"
        }, 
        {
         "id":528,
         "type":"decal"
        }, 
        {
         "id":529,
         "type":"decal"
        }, 
        {
         "id":530,
         "type":"decal"
        }, 
        {
         "id":531,
         "type":"decal"
        }, 
        {
         "id":532,
         "type":"decal"
        }, 
        {
         "id":533,
         "type":"decal"
        }, 
        {
         "id":534,
         "type":"decal"
        }, 
        {
         "id":541,
         "type":"decal"
        }, 
        {
         "id":542,
         "type":"decal"
        }, 
        {
         "id":543,
         "type":"decal"
        }, 
        {
         "id":564,
         "type":"decal"
        }, 
        {
         "id":565,
         "type":"decal"
        }, 
        {
         "id":566,
         "type":"decal"
        }, 
        {
         "id":567,
         "type":"decal"
        }, 
        {
         "id":568,
         "type":"decal"
        }, 
        {
         "id":569,
         "type":"decal"
        }, 
        {
         "id":570,
         "type":"decal"
        }, 
        {
         "id":571,
         "type":"decal"
        }, 
        {
         "id":572,
         "type":"decal"
        }, 
        {
         "id":573,
         "type":"decal"
        }, 
        {
         "id":574,
         "type":"decal"
        }, 
        {
         "id":575,
         "type":"decal"
        }, 
        {
         "id":576,
         "type":"decal"
        }, 
        {
         "id":577,
         "type":"decal"
        }, 
        {
         "id":586,
         "type":"decal"
        }, 
        {
         "id":587,
         "type":"decal"
        }, 
        {
         "id":588,
         "type":"decal"
        }, 
        {
         "id":590,
         "type":"decal"
        }, 
        {
         "id":591,
         "type":"decal"
        }, 
        {
         "id":592,
         "type":"decal"
        }, 
        {
         "id":594,
         "type":"decal"
        }, 
        {
         "id":595,
         "type":"decal"
        }, 
        {
         "id":596,
         "type":"decal"
        }, 
        {
         "id":597,
         "type":"decal"
        }, 
        {
         "id":598,
         "type":"decal"
        }, 
        {
         "id":599,
         "type":"decal"
        }, 
        {
         "id":600,
         "type":"decal"
        }, 
        {
         "id":602,
         "type":"decal"
        }, 
        {
         "id":603,
         "type":"decal"
        }, 
        {
         "id":604,
         "type":"decal"
        }, 
        {
         "id":605,
         "type":"decal"
        }, 
        {
         "id":607,
         "type":"decal"
        }, 
        {
         "id":608,
         "type":"decal"
        }, 
        {
         "id":609,
         "type":"decal"
        }, 
        {
         "id":610,
         "type":"decal"
        }, 
        {
         "id":611,
         "type":"decal"
        }, 
        {
         "id":612,
         "type":"decal"
        }, 
        {
         "id":613,
         "type":"decal"
        }, 
        {
         "id":631,
         "type":"decal"
        }, 
        {
         "id":632,
         "type":"decal"
        }, 
        {
         "id":633,
         "type":"decal"
        }, 
        {
         "id":635,
         "type":"decal"
        }, 
        {
         "id":636,
         "type":"decal"
        }, 
        {
         "id":637,
         "type":"decal"
        }, 
        {
         "id":639,
         "type":"decal"
        }, 
        {
         "id":640,
         "type":"decal"
        }, 
        {
         "id":641,
         "type":"decal"
        }, 
        {
         "id":642,
         "type":"decal"
        }, 
        {
         "id":643,
         "type":"decal"
        }, 
        {
         "id":644,
         "type":"decal"
        }, 
        {
         "id":645,
         "type":"decal"
        }, 
        {
         "id":647,
         "type":"decal"
        }, 
        {
         "id":648,
         "type":"decal"
        }, 
        {
         "id":649,
         "type":"decal"
        }, 
        {
         "id":650,
         "type":"decal"
        }, 
        {
         "id":652,
         "type":"decal"
        }, 
        {
         "id":653,
         "type":"decal"
        }, 
        {
         "id":654,
         "type":"decal"
        }, 
        {
         "id":655,
         "type":"decal"
        }, 
        {
         "id":656,
         "type":"decal"
        }, 
        {
         "id":657,
         "type":"decal"
        }, 
        {
         "id":658,
         "type":"decal"
        }, 
        {
         "id":659,
         "type":"decal"
        }, 
        {
         "id":660,
         "type":"decal"
        }, 
        {
         "id":661,
         "type":"decal"
        }, 
        {
         "id":662,
         "type":"decal"
        }, 
        {
         "id":663,
         "type":"decal"
        }, 
        {
         "id":664,
         "type":"decal"
        }, 
        {
         "id":665,
         "type":"decal"
        }, 
        {
         "id":676,
         "type":"decal"
        }, 
        {
         "id":677,
         "type":"decal"
        }, 
        {
         "id":678,
         "type":"decal"
        }, 
        {
         "id":680,
         "type":"decal"
        }, 
        {
         "id":681,
         "type":"decal"
        }, 
        {
         "id":682,
         "type":"decal"
        }, 
        {
         "id":684,
         "type":"decal"
        }, 
        {
         "id":685,
         "type":"decal"
        }, 
        {
         "id":686,
         "type":"decal"
        }, 
        {
         "id":688,
         "type":"decal"
        }, 
        {
         "id":689,
         "type":"decal"
        }, 
        {
         "id":693,
         "type":"decal"
        }, 
        {
         "id":694,
         "type":"decal"
        }, 
        {
         "id":697,
         "type":"decal"
        }, 
        {
         "id":698,
         "type":"decal"
        }, 
        {
         "id":699,
         "type":"decal"
        }, 
        {
         "id":700,
         "type":"decal"
        }, 
        {
         "id":701,
         "type":"decal"
        }, 
        {
         "id":702,
         "type":"decal"
        }, 
        {
         "id":703,
         "type":"decal"
        }, 
        {
         "id":704,
         "type":"decal"
        }, 
        {
         "id":705,
         "type":"decal"
        }, 
        {
         "id":706,
         "type":"decal"
        }, 
        {
         "id":707,
         "type":"ground"
        }, 
        {
         "id":708,
         "type":"ground"
        }, 
        {
         "id":709,
         "type":"ground"
        }, 
        {
         "id":710,
         "type":"ground"
        }, 
        {
         "id":711,
         "type":"ground"
        }, 
        {
         "id":712,
         "type":"ground"
        }, 
        {
         "id":721,
         "type":"decal"
        }, 
        {
         "id":722,
         "type":"decal"
        }, 
        {
         "id":723,
         "type":"decal"
        }, 
        {
         "id":725,
         "type":"decal"
        }, 
        {
         "id":726,
         "type":"decal"
        }, 
        {
         "id":727,
         "type":"decal"
        }, 
        {
         "id":729,
         "type":"decal"
        }, 
        {
         "id":730,
         "type":"decal"
        }, 
        {
         "id":731,
         "type":"decal"
        }, 
        {
         "id":733,
         "type":"decal"
        }, 
        {
         "id":734,
         "type":"decal"
        }, 
        {
         "id":738,
         "type":"decal"
        }, 
        {
         "id":739,
         "type":"decal"
        }, 
        {
         "id":742,
         "type":"decal"
        }, 
        {
         "id":743,
         "type":"decal"
        }, 
        {
         "id":744,
         "type":"decal"
        }, 
        {
         "id":745,
         "type":"decal"
        }, 
        {
         "id":746,
         "type":"decal"
        }, 
        {
         "id":747,
         "type":"decal"
        }, 
        {
         "id":748,
         "type":"decal"
        }, 
        {
         "id":752,
         "type":"ground"
        }, 
        {
         "id":753,
         "type":"ground"
        }, 
        {
         "id":754,
         "type":"ground"
        }, 
        {
         "id":755,
         "type":"ground"
        }, 
        {
         "id":756,
         "type":"ground"
        }, 
        {
         "id":757,
         "type":"ground"
        }, 
        {
         "id":766,
         "type":"decal"
        }, 
        {
         "id":767,
         "type":"decal"
        }, 
        {
         "id":768,
         "type":"decal"
        }, 
        {
         "id":770,
         "type":"decal"
        }, 
        {
         "id":771,
         "type":"decal"
        }, 
        {
         "id":772,
         "type":"decal"
        }, 
        {
         "id":774,
         "type":"decal"
        }, 
        {
         "id":775,
         "type":"decal"
        }, 
        {
         "id":776,
         "type":"decal"
        }, 
        {
         "id":778,
         "type":"decal"
        }, 
        {
         "id":779,
         "type":"decal"
        }, 
        {
         "id":783,
         "type":"decal"
        }, 
        {
         "id":784,
         "type":"decal"
        }, 
        {
         "id":787,
         "type":"decal"
        }, 
        {
         "id":788,
         "type":"decal"
        }, 
        {
         "id":789,
         "type":"decal"
        }, 
        {
         "id":790,
         "type":"decal"
        }, 
        {
         "id":791,
         "type":"decal"
        }, 
        {
         "id":792,
         "type":"decal"
        }, 
        {
         "id":793,
         "type":"decal"
        }, 
        {
         "id":797,
         "type":"ground"
        }, 
        {
         "id":798,
         "type":"ground"
        }, 
        {
         "id":799,
         "type":"ground"
        }, 
        {
         "id":800,
         "type":"ground"
        }, 
        {
         "id":801,
         "type":"ground"
        }, 
        {
         "id":802,
         "type":"ground"
        }, 
        {
         "id":811,
         "type":"decal"
        }, 
        {
         "id":812,
         "type":"decal"
        }, 
        {
         "id":813,
         "type":"decal"
        }, 
        {
         "id":815,
         "type":"decal"
        }, 
        {
         "id":816,
         "type":"decal"
        }, 
        {
         "id":817,
         "type":"decal"
        }, 
        {
         "id":819,
         "type":"decal"
        }, 
        {
         "id":820,
         "type":"decal"
        }, 
        {
         "id":821,
         "type":"decal"
        }, 
        {
         "id":823,
         "type":"decal"
        }, 
        {
         "id":824,
         "type":"decal"
        }, 
        {
         "id":828,
         "type":"decal"
        }, 
        {
         "id":829,
         "type":"decal"
        }, 
        {
         "id":832,
         "type":"decal"
        }, 
        {
         "id":833,
         "type":"decal"
        }, 
        {
         "id":834,
         "type":"decal"
        }, 
        {
         "id":835,
         "type":"decal"
        }, 
        {
         "id":836,
         "type":"decal"
        }, 
        {
         "id":837,
         "type":"decal"
        }, 
        {
         "id":838,
         "type":"decal"
        }, 
        {
         "id":842,
         "type":"ground"
        }, 
        {
         "id":843,
         "type":"ground"
        }, 
        {
         "id":844,
         "type":"ground"
        }, 
        {
         "id":845,
         "type":"ground"
        }, 
        {
         "id":846,
         "type":"ground"
        }, 
        {
         "id":847,
         "type":"ground"
        }, 
        {
         "id":856,
         "type":"decal"
        }, 
        {
         "id":857,
         "type":"decal"
        }, 
        {
         "id":858,
         "type":"decal"
        }, 
        {
         "id":860,
         "type":"decal"
        }, 
        {
         "id":861,
         "type":"decal"
        }, 
        {
         "id":862,
         "type":"decal"
        }, 
        {
         "id":864,
         "type":"decal"
        }, 
        {
         "id":865,
         "type":"decal"
        }, 
        {
         "id":866,
         "type":"decal"
        }, 
        {
         "id":868,
         "type":"decal"
        }, 
        {
         "id":869,
         "type":"decal"
        }, 
        {
         "id":873,
         "type":"decal"
        }, 
        {
         "id":874,
         "type":"decal"
        }, 
        {
         "id":877,
         "type":"decal"
        }, 
        {
         "id":878,
         "type":"decal"
        }, 
        {
         "id":879,
         "type":"decal"
        }, 
        {
         "id":880,
         "type":"decal"
        }, 
        {
         "id":881,
         "type":"decal"
        }, 
        {
         "id":882,
         "type":"decal"
        }, 
        {
         "id":883,
         "type":"decal"
        }, 
        {
         "id":901,
         "type":"decal"
        }, 
        {
         "id":902,
         "type":"decal"
        }, 
        {
         "id":903,
         "type":"decal"
        }, 
        {
         "id":905,
         "type":"decal"
        }, 
        {
         "id":906,
         "type":"decal"
        }, 
        {
         "id":907,
         "type":"decal"
        }, 
        {
         "id":909,
         "type":"decal"
        }, 
        {
         "id":910,
         "type":"decal"
        }, 
        {
         "id":911,
         "type":"decal"
        }, 
        {
         "id":913,
         "type":"decal"
        }, 
        {
         "id":914,
         "type":"decal"
        }, 
        {
         "id":918,
         "type":"decal"
        }, 
        {
         "id":919,
         "type":"decal"
        }, 
        {
         "id":922,
         "type":"decal"
        }, 
        {
         "id":923,
         "type":"decal"
        }, 
        {
         "id":924,
         "type":"decal"
        }, 
        {
         "id":925,
         "type":"decal"
        }, 
        {
         "id":926,
         "type":"decal"
        }, 
        {
         "id":927,
         "type":"decal"
        }, 
        {
         "id":928,
         "type":"decal"
        }, 
        {
         "id":946,
         "type":"decal"
        }, 
        {
         "id":947,
         "type":"decal"
        }, 
        {
         "id":948,
         "type":"decal"
        }, 
        {
         "id":950,
         "type":"decal"
        }, 
        {
         "id":951,
         "type":"decal"
        }, 
        {
         "id":952,
         "type":"decal"
        }, 
        {
         "id":954,
         "type":"decal"
        }, 
        {
         "id":955,
         "type":"decal"
        }, 
        {
         "id":956,
         "type":"decal"
        }, 
        {
         "id":958,
         "type":"decal"
        }, 
        {
         "id":959,
         "type":"decal"
        }, 
        {
         "id":963,
         "type":"decal"
        }, 
        {
         "id":964,
         "type":"decal"
        }, 
        {
         "id":967,
         "type":"decal"
        }, 
        {
         "id":968,
         "type":"decal"
        }, 
        {
         "id":969,
         "type":"decal"
        }, 
        {
         "id":970,
         "type":"decal"
        }, 
        {
         "id":971,
         "type":"decal"
        }, 
        {
         "id":972,
         "type":"decal"
        }, 
        {
         "id":973,
         "type":"decal"
        }, 
        {
         "id":991,
         "type":"decal"
        }, 
        {
         "id":992,
         "type":"decal"
        }, 
        {
         "id":993,
         "type":"decal"
        }, 
        {
         "id":995,
         "type":"decal"
        }, 
        {
         "id":996,
         "type":"decal"
        }, 
        {
         "id":997,
         "type":"decal"
        }, 
        {
         "id":999,
         "type":"decal"
        }, 
        {
         "id":1000,
         "type":"decal"
        }, 
        {
         "id":1001,
         "type":"decal"
        }, 
        {
         "id":1003,
         "type":"decal"
        }, 
        {
         "id":1004,
         "type":"decal"
        }, 
        {
         "id":1008,
         "type":"decal"
        }, 
        {
         "id":1009,
         "type":"decal"
        }, 
        {
         "id":1012,
         "type":"decal"
        }, 
        {
         "id":1013,
         "type":"decal"
        }, 
        {
         "id":1014,
         "type":"decal"
        }, 
        {
         "id":1015,
         "type":"decal"
        }, 
        {
         "id":1016,
         "type":"decal"
        }, 
        {
         "id":1017,
         "type":"decal"
        }, 
        {
         "id":1018,
         "type":"decal"
        }, 
        {
         "id":1036,
         "type":"decal"
        }, 
        {
         "id":1037,
         "type":"decal"
        }, 
        {
         "id":1038,
         "type":"decal"
        }, 
        {
         "id":1040,
         "type":"decal"
        }, 
        {
         "id":1041,
         "type":"decal"
        }, 
        {
         "id":1042,
         "type":"decal"
        }, 
        {
         "id":1044,
         "type":"decal"
        }, 
        {
         "id":1045,
         "type":"decal"
        }, 
        {
         "id":1046,
         "type":"decal"
        }, 
        {
         "id":1048,
         "type":"decal"
        }, 
        {
         "id":1049,
         "type":"decal"
        }, 
        {
         "id":1053,
         "type":"decal"
        }, 
        {
         "id":1054,
         "type":"decal"
        }, 
        {
         "id":1057,
         "type":"decal"
        }, 
        {
         "id":1058,
         "type":"decal"
        }, 
        {
         "id":1059,
         "type":"decal"
        }, 
        {
         "id":1060,
         "type":"decal"
        }, 
        {
         "id":1061,
         "type":"decal"
        }, 
        {
         "id":1062,
         "type":"decal"
        }, 
        {
         "id":1063,
         "type":"decal"
        }, 
        {
         "id":1102,
         "type":"decal"
        }, 
        {
         "id":1103,
         "type":"decal"
        }, 
        {
         "id":1104,
         "type":"decal"
        }, 
        {
         "id":1105,
         "type":"decal"
        }, 
        {
         "id":1106,
         "type":"decal"
        }, 
        {
         "id":1107,
         "type":"decal"
        }, 
        {
         "id":1112,
         "type":"decal"
        }, 
        {
         "id":1113,
         "type":"decal"
        }, 
        {
         "id":1114,
         "type":"decal"
        }, 
        {
         "id":1115,
         "type":"decal"
        }, 
        {
         "id":1116,
         "type":"decal"
        }, 
        {
         "id":1117,
         "type":"decal"
        }, 
        {
         "id":1147,
         "type":"decal"
        }, 
        {
         "id":1148,
         "type":"decal"
        }, 
        {
         "id":1149,
         "type":"decal"
        }, 
        {
         "id":1150,
         "type":"decal"
        }, 
        {
         "id":1151,
         "type":"decal"
        }, 
        {
         "id":1152,
         "type":"decal"
        }, 
        {
         "id":1153,
         "type":"decal"
        }, 
        {
         "id":1157,
         "type":"decal"
        }, 
        {
         "id":1158,
         "type":"decal"
        }, 
        {
         "id":1159,
         "type":"decal"
        }, 
        {
         "id":1160,
         "type":"decal"
        }, 
        {
         "id":1161,
         "type":"decal"
        }, 
        {
         "id":1162,
         "type":"decal"
        }, 
        {
         "id":1163,
         "type":"decal"
        }, 
        {
         "id":1164,
         "type":"decal"
        }, 
        {
         "id":1192,
         "type":"ground"
        }, 
        {
         "id":1193,
         "type":"ground"
        }, 
        {
         "id":1194,
         "type":"ground"
        }, 
        {
         "id":1195,
         "type":"ground"
        }, 
        {
         "id":1196,
         "type":"ground"
        }, 
        {
         "id":1197,
         "type":"ground"
        }, 
        {
         "id":1198,
         "type":"ground"
        }, 
        {
         "id":1199,
         "type":"decal"
        }, 
        {
         "id":1202,
         "type":"ground"
        }, 
        {
         "id":1203,
         "type":"ground"
        }, 
        {
         "id":1204,
         "type":"ground"
        }, 
        {
         "id":1205,
         "type":"ground"
        }, 
        {
         "id":1206,
         "type":"ground"
        }, 
        {
         "id":1207,
         "type":"ground"
        }, 
        {
         "id":1208,
         "type":"decal"
        }, 
        {
         "id":1209,
         "type":"decal"
        }, 
        {
         "id":1237,
         "type":"decal"
        }, 
        {
         "id":1238,
         "type":"decal"
        }, 
        {
         "id":1239,
         "type":"decal"
        }, 
        {
         "id":1240,
         "type":"decal"
        }, 
        {
         "id":1241,
         "type":"decal"
        }, 
        {
         "id":1242,
         "type":"decal"
        }, 
        {
         "id":1243,
         "type":"decal"
        }, 
        {
         "id":1244,
         "type":"decal"
        }, 
        {
         "id":1245,
         "type":"decal"
        }, 
        {
         "id":1247,
         "type":"decal"
        }, 
        {
         "id":1248,
         "type":"decal"
        }, 
        {
         "id":1249,
         "type":"decal"
        }, 
        {
         "id":1250,
         "type":"decal"
        }, 
        {
         "id":1251,
         "type":"decal"
        }, 
        {
         "id":1252,
         "type":"decal"
        }, 
        {
         "id":1253,
         "type":"decal"
        }, 
        {
         "id":1254,
         "type":"decal"
        }, 
        {
         "id":1282,
         "type":"decal"
        }, 
        {
         "id":1283,
         "type":"decal"
        }, 
        {
         "id":1284,
         "type":"decal"
        }, 
        {
         "id":1285,
         "type":"decal"
        }, 
        {
         "id":1286,
         "type":"decal"
        }, 
        {
         "id":1287,
         "type":"decal"
        }, 
        {
         "id":1288,
         "type":"decal"
        }, 
        {
         "id":1289,
         "type":"decal"
        }, 
        {
         "id":1290,
         "type":"decal"
        }, 
        {
         "id":1292,
         "type":"decal"
        }, 
        {
         "id":1293,
         "type":"decal"
        }, 
        {
         "id":1294,
         "type":"decal"
        }, 
        {
         "id":1295,
         "type":"decal"
        }, 
        {
         "id":1296,
         "type":"decal"
        }, 
        {
         "id":1297,
         "type":"decal"
        }, 
        {
         "id":1298,
         "type":"decal"
        }, 
        {
         "id":1299,
         "type":"decal"
        }, 
        {
         "id":1327,
         "type":"decal"
        }, 
        {
         "id":1328,
         "type":"decal"
        }, 
        {
         "id":1329,
         "type":"decal"
        }, 
        {
         "id":1330,
         "type":"decal"
        }, 
        {
         "id":1331,
         "type":"decal"
        }, 
        {
         "id":1332,
         "type":"decal"
        }, 
        {
         "id":1333,
         "type":"decal"
        }, 
        {
         "id":1334,
         "type":"decal"
        }, 
        {
         "id":1335,
         "type":"decal"
        }, 
        {
         "id":1337,
         "type":"decal"
        }, 
        {
         "id":1338,
         "type":"decal"
        }, 
        {
         "id":1339,
         "type":"decal"
        }, 
        {
         "id":1340,
         "type":"decal"
        }, 
        {
         "id":1341,
         "type":"decal"
        }, 
        {
         "id":1342,
         "type":"decal"
        }, 
        {
         "id":1343,
         "type":"decal"
        }, 
        {
         "id":1344,
         "type":"decal"
        }, 
        {
         "id":1372,
         "type":"decal"
        }, 
        {
         "id":1373,
         "type":"decal"
        }, 
        {
         "id":1374,
         "type":"decal"
        }, 
        {
         "id":1375,
         "type":"decal"
        }, 
        {
         "id":1376,
         "type":"decal"
        }, 
        {
         "id":1377,
         "type":"decal"
        }, 
        {
         "id":1378,
         "type":"decal"
        }, 
        {
         "id":1379,
         "type":"decal"
        }, 
        {
         "id":1380,
         "type":"decal"
        }, 
        {
         "id":1382,
         "type":"decal"
        }, 
        {
         "id":1383,
         "type":"decal"
        }, 
        {
         "id":1384,
         "type":"decal"
        }, 
        {
         "id":1385,
         "type":"decal"
        }, 
        {
         "id":1386,
         "type":"decal"
        }, 
        {
         "id":1387,
         "type":"decal"
        }],
 "tilewidth":16,
 "type":"tileset",
 "version":"1.10"
};